import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { ProjectService } from 'features/project/service/service'

export { ProjectService } from 'features/project/service/service'

export function useProjectService(): ProjectService {
  const client = useApiClient()
  return useMemo(() => new ProjectService(client), [client])
}
